package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class ActivityDto(
    val events: List<EventDto> = emptyList(),
    val bookings: List<BookingDto> = emptyList()
) {
    val totalCount: Int get() = events.size + bookings.size
}

@Serializable
data class ActivityCountDto(
    val events: Long = 0,
    val bookings: Long = 0,
    val total: Long = 0,
)
